<script>
export default {
    name: "VContainer"
}
</script>

<template>
    <div class="v-container">
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>

.v-container {
    box-sizing: border-box;
    padding: 0 16px;
    height: 100%;
}
</style>